/* ADD GROUPS */
export const REMOVE_GROUP_PARTICIPANT = "REMOVE_GROUP_PARTICIPANT"
export const REMOVE_GROUP_PARTICIPANT_SUCCESS =
  "REMOVE_GROUP_PARTICIPANT_SUCCESS"
export const REMOVE_GROUP_PARTICIPANT_CLEAN = "REMOVE_GROUP_PARTICIPANT_CLEAN"
export const REMOVE_GROUP_PARTICIPANT_ERROR = "REMOVE_GROUP_PARTICIPANT_ERROR"
